module.exports = __webpack_public_path__ + "static/media/profile.27eb0df6.svg";